import React, { useState, useEffect } from "react";
import axios from "axios";
import { Grid, Box } from "@mui/material";
import { API_BASE_URL } from "../../config/constants";
import CustomDatePicker from "./../../utility-v1/CustomDatePicker";
import SalesRecord from "./../ShippedItems/SalesRecord";
import GenerateLabel from "./../ShippedItems/GenerateLabel";

const shipment = () => {
  const [profitStartDate, setProfitStartDate] = useState("");
  const [profitEndDate, setProfitEndDate] = useState("");
  const [salesData, setSalesData] = useState([]);
  const [selectedShipments, setSelectedShipments] = useState([]);

  useEffect(() => {
    fetchSalesReport(profitStartDate, profitEndDate);
  }, []);

  const fetchSalesReport = () => {
    axios
      .get(`${API_BASE_URL}/salesreportbystatus?status=SP`)
      .then((response) => groupSalesById(response.data))
      .catch((error) => console.error("Error fetching sales data:", error));
  };

  const handleShipmentUpdate = (salesId, shipmentDetails) => {
    const { shipmentPrice, shipmentMethod, trackingId } = shipmentDetails;

    // ✅ Prevent update if shipment details are incomplete
    if (!shipmentPrice || isNaN(shipmentPrice) || shipmentPrice <= 0) {
      alert("Please fill in all required shipment details.");
      return;
    }

    console.log(
      `Updating shipment for Sale ID ${salesId} with`,
      shipmentDetails
    ); // Debugging log

    axios
      .put(`${API_BASE_URL}/sales/${salesId}/shipment`, {
        shipmentPrice,
        shipmentMethod,
        trackingId,
      })
      .then((response) => {
        console.log("Shipment updated successfully:", response.data); // ✅ Debugging log

        setSalesData((prevSales) => {
          const updatedSales = prevSales.filter(
            (sale) => sale.sales_id !== salesId
          );

          console.log("Updated Sales List:", updatedSales); // ✅ Debugging log
          return updatedSales;
        });
      })
      .catch((error) => {
        console.error("Error updating shipment details:", error);
        alert("Failed to update shipment details. Please try again.");
      });
  };

  const groupSalesById = (sales) => {
    const groupedSales = sales.reduce((acc, sale) => {
      if (!acc[sale.sales_id]) {
        acc[sale.sales_id] = {
          sales_id: sale.sales_id,
          sales_date: sale.sales_date,
          total_price: parseFloat(sale.total_price),
          name: sale.name,
          buyer_details: sale.buyer_details,
          pincode: sale.pincode,
          state: sale.state,
          phone_number: sale.phone_number,
          shipment_price: sale.shipment_price
            ? parseFloat(sale.shipment_price)
            : 0,
          sales_status: sale.sales_status,
          items: [],
        };
      }
      acc[sale.sales_id].items.push({
        item_label: sale.item_label,
        quantity: sale.quantity,
        image: sale.image,
      });

      return acc;
    }, {});

    setSalesData(Object.values(groupedSales));
  };

  // ✅ Fix: Define the function before passing it as a prop
  const handleSelectShipment = (salesId) => {
    setSelectedShipments((prev) =>
      prev.includes(salesId)
        ? prev.filter((id) => id !== salesId)
        : [...prev, salesId]
    );
  };

  return (
    <Box sx={{ p: 0 }}>
      <Grid container spacing={2} sx={{ mb: 2 }} justifyContent="center">
        {/* Generate Label Button */}
        <Grid container justifyContent="flex-end" sx={{ mt: 2 }}>
          <GenerateLabel
            selectedSales={salesData.filter((sale) =>
              selectedShipments.includes(sale.sales_id)
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <SalesRecord
            salesData={salesData}
            rowsPerPage={10}
            onSelectShipment={handleSelectShipment} // ✅ Pass the function
            selectedShipments={selectedShipments}
            onShipmentUpdate={handleShipmentUpdate}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default shipment;
